import { MinusCircleOutlined } from '@ant-design/icons';
import { Button, Checkbox, Col, Form, Input, Row } from 'antd';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  addContactPersons,
  removeContactPersons,
  updateContactPersons,
} from '../../../../../contextRedux/WorkPlace/WorkPlaceModel';
import { RootState } from '../../../../../store';

const ContactPersonTab: React.FC = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const workPlaceId = useSelector((state: RootState) => state?.models?.workPlace?.id) ?? '';
  const initialValues = useSelector((state: RootState) => state?.models?.workPlace?.contactPersons || []);

  useEffect(() => {
    form.setFieldsValue({ contactPersons: Array.isArray(initialValues) ? initialValues : [] });
  }, [initialValues, form]);

  const handleAddContactPerson = (addFn: any) => {
    const newContactPerson = {
      id: null,
      workPlaceId,
      companyId: '',
      name: '',
      phone: '',
      email: '',
      isActive: false,
      isDefaultOnInterventionFile: false,
      receivesInterventionFileEmails: false,
      role: '',
    };

    addFn(newContactPerson);
    dispatch(addContactPersons(newContactPerson));
  };

  const handleRemoveContactPerson = (index: number, removeFn: any) => {
    removeFn(index);
    dispatch(removeContactPersons(index));
  };

  const handleValuesChange = (changedValues: any, _allValues: any) => {
    const changedContactPersons = changedValues?.contactPersons;
    if (changedContactPersons) {
      changedContactPersons.forEach((changedContactPerson: any, index: number) => {
        if (changedContactPerson) {
          dispatch(updateContactPersons({ index, updates: changedContactPerson }));
        }
      });
    }
  };

  return (
    <Form
      form={form}
      name='contactPersonForm'
      initialValues={{ contactPersons: initialValues }}
      onValuesChange={handleValuesChange}
      layout='vertical'
      style={{ margin: '20px 20px' }}
    >
      <Form.List name='contactPersons'>
        {(fields, { add, remove }) => (
          <>
            {fields.map((field, _index) => (
              <Row key={field.key} gutter={[16, 16]} style={{ marginBottom: '20px' }}>
                <Col xs={24} sm={12}>
                  <Form.Item hidden={true} name={[field.name, 'id']}></Form.Item>
                  <Form.Item hidden={true} name={[field.name, 'companyId']}></Form.Item>
                  <Form.Item hidden={true} name={[field.name, 'workPlaceId']} initialValue={workPlaceId}></Form.Item>
                  <Form.Item
                    label='Nume'
                    name={[field.name, 'name']}
                    rules={[{ required: true, message: 'Introdu numele!' }]}
                  >
                    <Input placeholder='Introdu denumire' />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                  <Form.Item
                    label='Telefon'
                    name={[field.name, 'phone']}
                    rules={[{ required: true, message: 'Introdu telefon!' }]}
                  >
                    <Input placeholder='Introdu telefon' />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                  <Form.Item
                    label='Email'
                    name={[field.name, 'email']}
                    rules={[{ required: true, message: 'Introdu email!' }]}
                  >
                    <Input placeholder='Introdu email' />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                  <Form.Item
                    label='Rol'
                    name={[field.name, 'role']}
                    rules={[{ required: true, message: 'Introdu rol!' }]}
                  >
                    <Input placeholder='Introdu rol' />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                  <Form.Item label='Status' name={[field.name, 'isActive']} valuePropName='checked'>
                    <Checkbox />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                  <Form.Item
                    label='Default pe fisa de interventie'
                    name={[field.name, 'isDefaultOnInterventionFile']}
                    valuePropName='checked'
                  >
                    <Checkbox />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                  <Form.Item
                    label='Primeste fise de interventie'
                    name={[field.name, 'receivesInterventionFileEmails']}
                    valuePropName='checked'
                  >
                    <Checkbox />
                  </Form.Item>
                </Col>

                <Col lg={4}>
                  <Button
                    type='link'
                    icon={<MinusCircleOutlined />}
                    onClick={() => handleRemoveContactPerson(field.name, remove)}
                  />
                </Col>
              </Row>
            ))}

            <Form.Item>
              <Button type='dashed' onClick={() => handleAddContactPerson(add)} style={{ width: '100%' }}>
                Adaugă Persoană de Contact
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>
    </Form>
  );
};

export default ContactPersonTab;
